export default __webpack_public_path__ + "locales/hy-AM/DataReassignmentDialog.json?hash=7fce328349a136c0d306c63516bc83ee";